import { $ } from '../../../shared/js/utils/dom';
import { currentBreakpoint } from '../../../shared/js/globals/breakpoints';
import Bus from '../../../shared/js/modules/event-bus';

const html = $('html');
const init = () => {
  Bus.subscribe('overlay_show', 'ScrollLockActivate', lock);
  Bus.subscribe('overlay_hide', 'ScrollLockDeactivate', unlock);
};

const lock = () => {
  const breakpoint = currentBreakpoint;
  if (breakpoint !== 'desktop' && breakpoint !== 'bigscreen') {
    html.classList.add('has-scroll-lock');
  }
};

const unlock = () => {
  html.classList.remove('has-scroll-lock');
};

init();
